import React from "react";
import "./LiveCoach.css";

function LiveCoach({
  suggestedAction = "Continue monitoring",
  avoid = "Do not chase the move before confirmation.",
  status = "MONITORING",
  grade = "—",
  tradeStage = "WAITING",
}) {
  const getStatusClass = (value = "") => {
    const normalizedValue = value.toLowerCase();

    if (
      normalizedValue.includes("blocked") ||
      normalizedValue.includes("risk") ||
      normalizedValue.includes("do not")
    ) {
      return "liveCoachStatusDanger";
    }

    if (
      normalizedValue.includes("ready") ||
      normalizedValue.includes("confirmed")
    ) {
      return "liveCoachStatusPositive";
    }

    return "liveCoachStatusWaiting";
  };

  const stages = [
    "Scanning",
    "Setup Found",
    "Waiting",
    "Entry Confirmed",
    "In Position",
  ];
  const normalizedStage = `${tradeStage} ${status}`.toLowerCase();
  const activeStage = normalizedStage.includes("position")
    ? 4
    : normalizedStage.includes("confirmed") ||
      normalizedStage.includes("ready")
    ? 3
    : normalizedStage.includes("wait") ||
      normalizedStage.includes("monitor") ||
      normalizedStage.includes("building") ||
      normalizedStage.includes("breakout")
    ? 2
    : normalizedStage.includes("setup")
    ? 1
    : 0;

  return (
    <div className="liveCoach" data-tour-id="nina-live-coach">
      <div className="liveCoachHeader">
        <div>
          <span className="liveCoachEyebrow">
            AI LIVE COACH
          </span>

          <h3>💬 Real-Time Guidance</h3>
        </div>

        <div className="liveCoachGrade">
          <span>Setup Grade</span>
          <strong>{grade}</strong>
        </div>
      </div>

      <div className="liveCoachAction">
        <span>Do Now</span>
        <strong>{suggestedAction}</strong>
      </div>

      <div className="liveCoachGuidance">
        <div>
          <span>Avoid</span>
          <strong>{avoid}</strong>
        </div>
      </div>


      <div className="liveCoachStage">
        <div className="liveCoachStageHeader">
          <span>Trade Stage</span>
          <strong>{tradeStage}</strong>
        </div>

        <ol aria-label="Trade stage progress">
          {stages.map((stage, index) => (
            <li
              className={
                index < activeStage
                  ? "isComplete"
                  : index === activeStage
                  ? "isActive"
                  : ""
              }
              key={stage}
            >
              <span aria-hidden="true">{index + 1}</span>
              <small>{stage}</small>
            </li>
          ))}
        </ol>
      </div>

      <div className="liveCoachQuestion">
        <span>💬 Ask AI Assistant</span>

        <small>
          Conversational guidance coming in Phase 2
        </small>
      </div>
    </div>
  );
}

export default LiveCoach;
